// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardTcsWrapperModelsClaimModel {
    static getAttributeTypeMap() {
        return CardTcsWrapperModelsClaimModel.attributeTypeMap;
    }
}
CardTcsWrapperModelsClaimModel.discriminator = undefined;
CardTcsWrapperModelsClaimModel.additionalProperties = false;
CardTcsWrapperModelsClaimModel.attributeTypeMap = [
    {
        "name": "dateProcessed",
        "baseName": "dateProcessed",
        "type": "string"
    },
    {
        "name": "dateOfFill",
        "baseName": "dateOfFill",
        "type": "string"
    },
    {
        "name": "initialOutOfPocket",
        "baseName": "initialOutOfPocket",
        "type": "string"
    },
    {
        "name": "prescriberName",
        "baseName": "prescriberName",
        "type": "string"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "quantityDispensed",
        "baseName": "quantityDispensed",
        "type": "string"
    },
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "string"
    },
    {
        "name": "refillNumber",
        "baseName": "refillNumber",
        "type": "string"
    },
    {
        "name": "refillsAuthorized",
        "baseName": "refillsAuthorized",
        "type": "string"
    },
    {
        "name": "benefitPaid",
        "baseName": "benefitPaid",
        "type": "string"
    },
    {
        "name": "medication",
        "baseName": "medication",
        "type": "CardTcsWrapperModelsMedicationModel"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "ndcPromotionGroupId",
        "baseName": "ndcPromotionGroupId",
        "type": "string"
    },
    {
        "name": "claimStatus",
        "baseName": "claimStatus",
        "type": "string"
    },
    {
        "name": "rejectDescription",
        "baseName": "rejectDescription",
        "type": "string"
    },
    {
        "name": "mailInRebate",
        "baseName": "mailInRebate",
        "type": "string"
    },
];
//# sourceMappingURL=cardTcsWrapperModelsClaimModel.js.map